import type { SiteContext } from "../admin/api";

type SiteSwitcherProps = {
  context: SiteContext | null;
  value: number | null;
  onChange: (siteId: number | null) => void;
};

export function SiteSwitcher({ context, value, onChange }: SiteSwitcherProps) {
  if (!context) return null;

  // Scoped users can't switch -- just show which site they're viewing.
  if (context.scoped) {
    return <span className="site-chip">Site: {context.site_name ?? "Assigned site"}</span>;
  }

  // Company-wide user with no sites configured yet -- nothing to switch.
  if (context.sites.length === 0) return null;

  return (
    <label className="site-switcher">
      <span className="site-switcher-label">Site</span>
      <select
        className="site-switcher-select"
        value={value == null ? "" : String(value)}
        onChange={(event) => onChange(event.target.value ? Number(event.target.value) : null)}
        aria-label="Filter dashboard by site"
      >
        <option value="">All sites</option>
        {context.sites.map((site) => (
          <option key={site.id} value={String(site.id)}>
            {site.name}
          </option>
        ))}
      </select>
    </label>
  );
}
